/**
 * @param {HTMLElement} element
 * @returns {number}
 */
export function getWidth(element) {
  const style = getComputedStyle(element);
  return (
    element.offsetWidth +
    parseFloat(style.paddingLeft) +
    parseFloat(style.paddingRight) +
    parseFloat(style.borderLeftWidth) +
    parseFloat(style.borderRightWidth)
  );
}

/**
 * @param {HTMLElement} element
 * @returns {number}
 */
export function getHeight(element) {
  const style = getComputedStyle(element);
  return (
    element.offsetHeight +
    parseFloat(style.paddingTop) +
    parseFloat(style.paddingBottom) +
    parseFloat(style.borderTopWidth) +
    parseFloat(style.borderBottomWidth)
  );
}

/**
 * @param {HTMLElement} element
 * @returns {number}
 */
export function getOuterHeight(element) {
  const style = getComputedStyle(element);
  return element.offsetHeight + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
}

/**
 * @param {HTMLElement} element
 * @returns {number}
 */
export function getOuterWidth(element) {
  const style = getComputedStyle(element);
  return element.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);
}
